export default "__VITE_ASSET__c263798d__"